import TFacturasHistorial from "./TFacturasHistorial"
import { obtenerFacturaHistorialAction } from "./../../../ducks/facturacionHistorialDuck"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

const VFacturasHistorial = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerFacturaHistorialAction())
    },[])
    return (
        <div>
            <TFacturasHistorial />
        </div>
    )
}
export default VFacturasHistorial